import { render, staticRenderFns } from "./dsgvo.vue?vue&type=template&id=62b8e337&scoped=true&"
import script from "./dsgvo.vue?vue&type=script&lang=js&"
export * from "./dsgvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8e337",
  null
  
)

export default component.exports